<template>
  <div class="lang-select" :class="{ opened }" v-click-outside="close">
    <div class="lang-input" @click="toggle">
      <div class="lang-title active-lang">
        {{ activeLang }}
      </div>
      <img src="@/assets/icons/lang-select-arrow.svg" alt="" />
    </div>
    <div class="lang-select-dropdown" :class="{'down' : down}" v-show="opened">
      <div v-for="lang in langList" :key="lang" class="lang-option" @click="selectLang(lang)">
        <Checkbox :value="activeLang === lang" />
        <div class="lang-title lang-option-title">
          {{ lang }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Checkbox from '@/components/form/Checkbox'
import outsize from '@/mixins/outsize'
import locales from '@/locales'
import moment from 'moment'

export default {
  name: 'LangSelect',
  components: { Checkbox },
  props: {
    down: Boolean
  },
  mixins: [outsize],
  data: () => ({
    opened: false,
  }),
  computed: {
    activeLang: {
      get() {
        return this.$i18n.locale
      },
      set(lang) {
        this.$i18n.locale = lang
        moment.locale(lang)
        localStorage.setItem('lang', lang)
        this.$router.replace({
          ...this.$route,
          query: {
            ...this.$route.query,
            lang,
          },
        })
        this.$forceUpdate()
      },
    },
    langList() {
      return Object.keys(locales).sort((a, b) => (a === this.$i18n.locale ? -1 : 1))
    },
  },
  methods: {
    selectLang(lang) {
      this.activeLang = lang
      this.close()
    },
    toggle() {
      this.opened = !this.opened
    },
    close() {
      this.opened = false
    },
  },
}
</script>

<style lang="scss">
.lang-select {
  position: relative;
  z-index: 2;

  &.opened {
    .lang-input img {
      transform: rotate(180deg);
    }
  }

  .lang-title {
    text-transform: uppercase;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 147.5%;
    color: #474747;

    @include mobile {
      font-size: 15px;
      line-height: 20px;
    }
  }

  .lang-input {
    display: inline-flex;
    align-items: center;
    z-index: 2;
    cursor: pointer;

    .active-lang {
      margin-right: 5px;
    }
  }

  .lang-select-dropdown {
    position: absolute;
    bottom: -25px;
    left: -15px;
    z-index: -1;
    display: grid;
    grid-gap: 15px;
    padding: 25px 34px 58px 15px;
    background: #ffffff;
    box-shadow: 0 12px 21px rgba(204, 215, 230, 0.19);
    border-radius: 5px;

    &.down {
      top: -25px;
      bottom: auto;
      padding: 58px 34px 25px 15px;
    }

    @include mobile {
      bottom: unset;
      top: -15px;
      padding: 48px 25px 25px 15px;
    }

    .lang-option {
      display: flex;
      align-items: center;
      padding: 5px;
      margin: -5px;

      &,
      * {
        cursor: pointer !important;
      }

      .checkbox {
        width: 15px;
        height: 15px;
        border-radius: 3px;
      }

      .lang-option-title {
        margin-left: 8px;
      }
    }
  }
}
</style>
